<button
  (click)="handleClick()"
  color="primary"
  mat-flat-button
  appMaterialElevation
  [defaultElevation]="0"
  [raisedElevation]="2"
  class="login-button"
>
  <span>{{ (isBusy ? isBusyLabel ?? label : label)  | translate}}</span>
  <mat-spinner diameter="20" *ngIf="isBusy"></mat-spinner>
</button>
